import React, { useEffect, useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';

import TituloAdmin from '@components/TituloAdmin';
import Boton from '@components/Boton';
import { cajaPrincipalStyle } from '@styles/cajaPrincipal';
import { cajaContenedorAdminStyle } from '@styles/cajaContenedorAdmin';
import { tablaEstylos, tablaTheadEstylos } from '@styles/tablaEstylos';
import { colors } from '@styles/colors';
import { getAllRolesApi, createRoleApi, updateRoleApi, deleteRoleApi } from '@api/wp/roles/rolesApi';

function Roles() {
  const navigate = useNavigate();
  const [roles, setRoles] = useState([]);
  const [rolesFiltrados, setRolesFiltrados] = useState([]);
  const [busqueda, setBusqueda] = useState('');
  const [cargando, setCargando] = useState(false);
  const [error, setError] = useState('');
  const [mensaje, setMensaje] = useState('');

  const [nuevo, setNuevo] = useState({ nombre: '', estado: 'Pendiente' });
  const [editId, setEditId] = useState(null);
  const [editData, setEditData] = useState({ nombre: '', estado: 'Pendiente' });

  const tablasedesRef = useRef(null);

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (!token) {
      navigate('/login');
    }
  }, [navigate]);

  const cargarRoles = async () => {
    try {
      setCargando(true);
      setError('');
      const resp = await getAllRolesApi();
      const lista = resp?.result || resp || [];
      setRoles(lista);
      setRolesFiltrados(lista);
    } catch (err) {
      console.error('Error al cargar roles:', err);
      setError('Error al cargar roles');
    } finally {
      setCargando(false);
    }
  };

  useEffect(() => {
    cargarRoles();
  }, []);

  useEffect(() => {
    if (!busqueda) {
      setRolesFiltrados(roles);
      return;
    }
    const term = busqueda.toLowerCase();
    setRolesFiltrados(
      (roles || []).filter(r =>
        String(r.id || '').includes(term) ||
        String(r.nombre || '').includes(term) ||
        String(r.estado || '').toLowerCase().includes(term)
      )
    );
  }, [busqueda, roles]);

  const handleCreate = async () => {
    try {
      setCargando(true);
      setError('');
      setMensaje('');
      const payload = {
        nombre: nuevo.nombre !== '' ? Number(nuevo.nombre) : null,
        estado: nuevo.estado || 'Pendiente'
      };
      await createRoleApi(payload);
      setNuevo({ nombre: '', estado: 'Pendiente' });
      setMensaje('Rol creado correctamente');
      await cargarRoles();
    } catch (err) {
      console.error('Error al crear rol:', err);
      setError('Error al crear rol');
    } finally {
      setCargando(false);
    }
  };

  const handleEdit = (row) => {
    setEditId(row.id);
    setEditData({ nombre: row.nombre || '', estado: row.estado || 'Pendiente' });
  };

  const handleUpdate = async () => {
    if (!editId) return;
    try {
      setCargando(true);
      setError('');
      setMensaje('');
      const payload = { nombre: editData.nombre !== '' ? Number(editData.nombre) : null, estado: editData.estado || 'Pendiente' };
      await updateRoleApi(editId, payload);
      setMensaje('Rol actualizado correctamente');
      setEditId(null);
      await cargarRoles();
    } catch (err) {
      console.error('Error al actualizar rol:', err);
      setError('Error al actualizar rol');
    } finally {
      setCargando(false);
    }
  };

  const handleDelete = async (row) => {
    if (!row?.id) return;
    if (!window.confirm('¿Eliminar este rol?')) return;
    try {
      setCargando(true);
      setError('');
      setMensaje('');
      await deleteRoleApi(row.id);
      setMensaje('Rol eliminado correctamente');
      await cargarRoles();
    } catch (err) {
      console.error('Error al eliminar rol:', err);
      setError('Error al eliminar rol');
    } finally {
      setCargando(false);
    }
  };

  return (
    <div id="cajaPrincipal" style={cajaPrincipalStyle}>
      <TituloAdmin
        titulo="Roles"
        imagen_titulo="servicios"
        subtitulo="Gestión de roles"
      />

      <div style={cajaContenedorAdminStyle}>
        {error && (
          <div style={{
            padding: '1.5vh 2vh', marginBottom: '2vh', borderRadius: '0.8vh', fontSize: '1.4vh', fontWeight: '500', fontFamily: 'Inter',
            border: `1px solid ${colors.errorText}`, backgroundColor: colors.errorShadow, color: colors.errorText
          }}>
            <strong>Error:</strong> {error}
          </div>
        )}
        {mensaje && (
          <div style={{
            padding: '1.5vh 2vh', marginBottom: '2vh', borderRadius: '0.8vh', fontSize: '1.4vh', fontWeight: '500', fontFamily: 'Inter',
            border: `1px solid ${colors.primary}`, backgroundColor: colors.resumenBg, color: colors.primaryText
          }}>
            {mensaje}
          </div>
        )}

        {/* Búsqueda */}
        <div style={{ display: 'flex', gap: '1vh', marginBottom: '2vh', alignItems: 'center' }}>
          <label style={{ fontFamily: 'Inter', fontSize: '1.5vh', color: colors.gray700 }}>Buscar:</label>
          <input
            type="text"
            value={busqueda}
            onChange={(e) => setBusqueda(e.target.value)}
            placeholder="ID, nombre o estado"
            style={{ width: '40vh', padding: '1.0vh', borderRadius: '0.6vh', border: `2px solid ${colors.gray200}`, fontSize: '1.6vh', backgroundColor: colors.white, outline: 'none', fontFamily: 'Inter' }}
          />
          <Boton label="Limpiar" onClick={() => setBusqueda('')} color={colors.secondaryButton} ancho="14vh" alto="4.5vh" />
        </div>

        {/* Formulario de creación */}
        <div style={{ marginBottom: '2.5vh' }}>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '2vh' }}>
            <div>
              <label>ID/Número (nombre):</label>
              <input type="number" value={nuevo.nombre} onChange={(e) => setNuevo({ ...nuevo, nombre: e.target.value })}
                style={{ width: '100%', padding: '1.2vh', borderRadius: '0.8vh', border: `2px solid ${colors.gray200}`, fontSize: '1.6vh', backgroundColor: colors.white, outline: 'none', fontFamily: 'Inter' }} />
            </div>
            <div>
              <label>Estado:</label>
              <select value={nuevo.estado} onChange={(e) => setNuevo({ ...nuevo, estado: e.target.value })}
                style={{ width: '100%', padding: '1.2vh', borderRadius: '0.8vh', border: `2px solid ${colors.gray200}`, fontSize: '1.6vh', backgroundColor: colors.white, outline: 'none', fontFamily: 'Inter' }}>
                <option value="Pendiente">Pendiente</option>
                <option value="Activo">Activo</option>
                <option value="Inactivo">Inactivo</option>
              </select>
            </div>
            <div style={{ display: 'flex', alignItems: 'flex-end' }}>
              <Boton label="Crear" onClick={handleCreate} color={colors.primary} ancho="18vh" alto="4.5vh" />
            </div>
          </div>
        </div>

        {/* Tabla de Roles */}
        <div style={{ overflowX: 'auto' }}>
          <table ref={tablasedesRef} className="display" style={tablaEstylos}>
            <thead style={tablaTheadEstylos}>
              <tr>
                <th>ID</th>
                <th>Nombre (int)</th>
                <th>Estado</th>
                <th>Fecha</th>
                <th>Acciones</th>
              </tr>
            </thead>
            <tbody>
              {rolesFiltrados.map(row => (
                <tr key={row.id}>
                  <td>{row.id}</td>
                  <td>{row.nombre ?? ''}</td>
                  <td>{row.estado ?? ''}</td>
                  <td>{row.fechaSis ?? ''}</td>
                  <td style={{ textAlign: 'center' }}>
                    {editId === row.id ? (
                      <div style={{ display: 'flex', gap: '1vh', alignItems: 'center', justifyContent: 'center' }}>
                        <input type="number" value={editData.nombre} onChange={(e) => setEditData({ ...editData, nombre: e.target.value })}
                          style={{ width: '16vh', padding: '0.8vh', borderRadius: '0.6vh', border: `2px solid ${colors.gray200}`, fontSize: '1.5vh', backgroundColor: colors.white, outline: 'none', fontFamily: 'Inter' }} />
                        <select value={editData.estado} onChange={(e) => setEditData({ ...editData, estado: e.target.value })}
                          style={{ width: '16vh', padding: '0.8vh', borderRadius: '0.6vh', border: `2px solid ${colors.gray200}`, fontSize: '1.5vh', backgroundColor: colors.white, outline: 'none', fontFamily: 'Inter' }}>
                          <option value="Pendiente">Pendiente</option>
                          <option value="Activo">Activo</option>
                          <option value="Inactivo">Inactivo</option>
                        </select>
                        <Boton label="Guardar" onClick={handleUpdate} color={colors.primary} ancho="12vh" alto="4.2vh" />
                        <Boton label="Cancelar" onClick={() => setEditId(null)} color={colors.secondaryButton} ancho="12vh" alto="4.2vh" />
                      </div>
                    ) : (
                      <div style={{ display: 'flex', gap: '1vh', alignItems: 'center', justifyContent: 'center' }}>
                        <Boton label="Editar" onClick={() => handleEdit(row)} color={colors.primary} ancho="12vh" alto="4.2vh" />
                        <Boton label="Eliminar" onClick={() => handleDelete(row)} color={colors.errorText} ancho="12vh" alto="4.2vh" />
                      </div>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

export default Roles;